import Dashboard from "../modules/user/dashboard/index.js";
import DashboardV2 from "../modules/user/dashboard-v2/index.js";
import MyProfile from "../modules/user/settings/myprofile/index.js";
import Products from '../modules/user/products/index.js'
import Expenses from "../modules/user/expenses/index.js";
import MarketplaceCredentials from "../modules/user/settings/MarketplaceCredentials/index.js";
import Alerts from "../modules/user/alert";
import Billing from "../modules/user/billing/index.js";
import UploadManager from "../modules/user/file-manager/index.js";
import AdvanceSettings from "../modules/user/settings/advanceSettings/index.js";
import UserList from "../modules/user/user-list/index.js";
import ManageUsers from "../modules/user/manage-users/index.js";
import AICopilot from "../modules/user/ai-copilot/index.js";
import SystemLogs from "../modules/admin/system-logs";

export const Users = [
  {
    path: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "dashboard-v2",
    element: <DashboardV2 />,
  },
  {
    path: "settings/products",
    element: <Products />
  },
  {
    path: "settings/expenses",
    element: <Expenses />
  },
  {
    path: "settings/marketplace-credentials",
    element: <MarketplaceCredentials />
  },
  {
    path: "settings/myprofile",
    element: <MyProfile/>
  },
  {
    path: "alerts",
    element: <Alerts/>
  },
  {
    path: "ai-copilot",
    element: <AICopilot />
  },
  {
    path: "settings/billing",
    element: <Billing />
  },
  {
    path: "settings/file-manager",
    element: <UploadManager />
  },
  {
    path: "settings/advance-settings",
    element: <AdvanceSettings />
  },
  {
    path: "settings/manage-seller",
    element: <UserList />
  },
  {
    path: "sub-users",
    element: <ManageUsers />
  },
  {
    path: "system-logs",
    element: <SystemLogs />,
  },
];
